<template>
  <b-modal
    id="'justificativaChecklist'"
    :ref="'justificativaChecklist'"
    hide-footer
    hide-header
    centered
    size="md"
    no-close-on-backdrop
  >
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="12">
            <b-button
              variant="none"
              class="close "
              @click="cancelar()"
            >
              <span aria-hidden="true">&times;</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            style="text-align:center;"
          >
            <h4>
              {{ textoApresentacao }}
            </h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-textarea
              v-model="mensagem"
              :placeholder="'Justifique'"
              rows="3"
              max-rows="3"
            />
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col cols="6">
            <b-btn
              variant="danger"
              class="w-100"
              @click="cancelar()"
            >Cancelar</b-btn>
          </b-col>
          <b-col cols="6">
            <b-btn
              variant="success"
              class="w-100"
              @click="confirmar()"
            >Confirmar</b-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'JustificativaModal',
  props: {
    textoApresentacao: {
      type: String,
      default: 'Informe o motivo da alteração do checklist!',
    },
  },
  data() {
    return {
      mensagem: '',
    }
  },
  methods: {
    cancelar() {
      this.mensagem = ''
      this.$emit('cancelar')
    },
    confirmar() {
      this.$emit('confirmar', this.mensagem)
    },
    show() {
      this.$refs.justificativaChecklist.show()
    },
    hide() {
      this.$refs.justificativaChecklist.hide()
    },
  },
}
</script>
